"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "font-bold" };
const _hoisted_2 = {
    key: 0,
    class: "input-group"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { key: 0 };
const _hoisted_5 = ["colspan"];
const _hoisted_6 = ["aria-sort", "onClick"];
const _hoisted_7 = { class: "flex items-center gap-2" };
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
    key: 0,
    class: "marso-icon-unsorted text-gray-dark"
};
const _hoisted_10 = {
    key: 1,
    class: "marso-icon-sort-asc"
};
const _hoisted_11 = {
    key: 2,
    class: "marso-icon-sort-desc"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = ["innerHTML"];
const _hoisted_16 = { key: 0 };
const _hoisted_17 = ["colspan"];
const _hoisted_18 = { key: 0 };
const _hoisted_19 = { key: 0 };
const _hoisted_20 = ["colspan"];
const _hoisted_21 = { key: 1 };
const _hoisted_22 = ["colspan"];
const debounce_1 = __importDefault(require("lodash/debounce"));
const vue_3 = require("vue");
const index_1 = require("./index");
const Form_1 = require("../Form");
const Pagination_vue_1 = __importDefault(require("../Pagination.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ResponsiveTable',
    props: {
        isBusy: {
            type: Boolean,
            default: false,
        },
        fields: {
            type: Array,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
        striped: Boolean,
        bodyRowExtraClasses: {
            type: String,
            default: "",
        },
        bodyExtraClasses: {
            type: String,
            default: "",
        },
        headExtraClasses: {
            type: String,
            default: "",
        },
        headRowExtraClasses: {
            type: String,
            default: "",
        },
        condensed: Boolean,
        panel: Boolean,
        sortBy: {
            type: String,
            default: (props) => props.fields[Object.keys(props.fields)[0]].key,
        },
        sortDesc: Boolean,
        pagination: Boolean,
        totalItems: Number,
        itemsPerPage: {
            type: Number,
            default: 40,
        },
        currentPage: {
            type: Number,
            default: 1,
        },
        storeAction: String,
        needRowClickEmit: Boolean,
    },
    emits: [
        "update:sortBy",
        "update:sortDesc",
        "update:currentPage",
        "update:itemsPerPage",
        "update:fields",
        "click:tableRow",
    ],
    setup(__props, { emit }) {
        const props = __props;
        const slots = (0, vue_3.useSlots)();
        const visibleFields = (0, vue_3.computed)(() => props.fields.filter((field) => (0, index_1.isFieldDefinition)(field) &&
            (typeof field.visible === "undefined" || field.visible)));
        const filterable = (0, vue_3.computed)(() => "undefined" !==
            typeof props.fields.find((field) => (0, index_1.isFieldDefinition)(field) &&
                (typeof field.filterable !== "undefined" || field.filterable)));
        const isFiltersClosed = (0, vue_3.ref)(false);
        const filters = (0, vue_3.ref)((() => {
            const filters = {};
            props.fields.forEach((field) => {
                var _a;
                if ((0, index_1.isFieldDefinition)(field) &&
                    typeof field.filterable !== "undefined" &&
                    field.filterable) {
                    filters[field.key] = (_a = field.filterValue) !== null && _a !== void 0 ? _a : "";
                }
            });
            return filters;
        })());
        const ariaSorts = (0, vue_3.computed)(() => {
            const sorts = {};
            props.fields.forEach((field) => {
                if ((0, index_1.isFieldDefinition)(field) &&
                    typeof field.sortable !== "undefined" &&
                    field.sortable) {
                    sorts[field.key] =
                        props.sortBy === field.key
                            ? props.sortDesc
                                ? "descending"
                                : "ascending"
                            : "none";
                }
            });
            return sorts;
        });
        const sortBy = (key) => {
            if (props.sortBy === key) {
                emit("update:sortDesc", !props.sortDesc);
            }
            else {
                emit("update:sortBy", key);
                emit("update:sortDesc", false);
            }
        };
        const page = (0, vue_3.ref)(props.currentPage);
        (0, vue_3.watch)(() => props.currentPage, (newValue, oldValue) => {
            page.value = newValue;
        });
        (0, vue_3.watch)(filters, (0, debounce_1.default)((newFilters) => {
            for (const key in newFilters) {
                if (newFilters.hasOwnProperty(key)) {
                    props.fields.forEach((field) => {
                        if ((0, index_1.isFieldDefinition)(field) && field.key === key) {
                            field.filterValue = newFilters[key];
                        }
                    });
                }
            }
            emit("update:fields", props.fields);
        }, 300), { deep: true });
        (0, vue_3.watch)(page, (newPage) => {
            emit("update:currentPage", newPage);
        });
        const rowClick = (event, item) => {
            if (props.needRowClickEmit) {
                emit("click:tableRow", event, item);
            }
        };
        const cellValueParser = (fieldKey, item) => {
            return fieldKey
                .split(".") //because of associations/relations e.g.: Users.vue::customer.customerName list field
                .reduce((a, b) => {
                return typeof a[b] !== "undefined" ? a[b] : "";
            }, item //initialValue
            );
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                (filterable.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                        (0, vue_2.createElementVNode)("button", {
                            class: "w-full bg-gray-dark text-white flex items-center justify-between gap-1 py-2 px-4",
                            onClick: _cache[0] || (_cache[0] = ($event) => (isFiltersClosed.value = !isFiltersClosed.value))
                        }, [
                            (0, vue_2.createElementVNode)("span", _hoisted_1, (0, vue_2.toDisplayString)(_ctx.$trans("filters", "Filters", "responsive_table")), 1),
                            (0, vue_2.createElementVNode)("i", {
                                class: (0, vue_2.normalizeClass)(["marso-icon-chevron-down text-xs transform-gpu transition-transform", { 'rotate-180': !isFiltersClosed.value }]),
                                "aria-hidden": "true"
                            }, null, 2)
                        ]),
                        (0, vue_2.createElementVNode)("div", {
                            class: (0, vue_2.normalizeClass)(["filters", { closed: isFiltersClosed.value, loading: __props.isBusy }])
                        }, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(visibleFields.value, (field) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, {
                                    key: field.key
                                }, [
                                    ('undefined' !== typeof filters.value[field.key])
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                                modelValue: filters.value[field.key],
                                                "onUpdate:modelValue": ($event) => ((filters.value[field.key]) = $event),
                                                placeholder: field.label,
                                                border: ""
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                                            (filters.value[field.key])
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                    key: 0,
                                                    class: "btn btn-secondary btn-outline",
                                                    onClick: ($event) => (filters.value[field.key] = '')
                                                }, (0, vue_2.toDisplayString)(_ctx.$trans("clear", "Clear", "responsive_table")), 9, _hoisted_3))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ], 64));
                            }), 128))
                        ], 2)
                    ], 64))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("table", {
                    class: (0, vue_2.normalizeClass)(["responsive table-auto min-w-full shadow-lg rounded mt-4", {
                            condensed: __props.condensed,
                            striped: __props.striped,
                            panel: __props.panel,
                            busy: __props.isBusy,
                        }])
                }, [
                    (0, vue_2.createElementVNode)("thead", {
                        class: (0, vue_2.normalizeClass)(["table-header-group", { [__props.headExtraClasses]: __props.headExtraClasses.length }])
                    }, [
                        ((0, vue_2.unref)(slots).header && (0, vue_2.unref)(slots).header().length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", _hoisted_4, [
                                (0, vue_2.createElementVNode)("th", {
                                    class: "bg-gray-darker text-white border-b-1 border-gray",
                                    colspan: visibleFields.value.length
                                }, [
                                    (0, vue_2.renderSlot)(_ctx.$slots, "header")
                                ], 8, _hoisted_5)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("tr", {
                            class: (0, vue_2.normalizeClass)(["hidden lg:table-row", { [__props.headRowExtraClasses]: __props.headRowExtraClasses.length }])
                        }, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(visibleFields.value, (field) => {
                                var _a, _b;
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", {
                                    key: field.key,
                                    class: (0, vue_2.normalizeClass)(["text-left font-bold bg-gray-darker text-white", { 'cursor-pointer': (_a = ariaSorts.value[field.key]) !== null && _a !== void 0 ? _a : false }]),
                                    "aria-sort": (_b = ariaSorts.value[field.key]) !== null && _b !== void 0 ? _b : null,
                                    onClick: ($event) => (sortBy(field.key))
                                }, [
                                    (0, vue_2.renderSlot)(_ctx.$slots, `head-${field.key}`, {}, () => [
                                        (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                            (0, vue_2.createElementVNode)("span", {
                                                innerHTML: field.label
                                            }, null, 8, _hoisted_8),
                                            (ariaSorts.value[field.key] && ariaSorts.value[field.key] === 'none')
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_9))
                                                : (ariaSorts.value[field.key] && ariaSorts.value[field.key] === 'ascending')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_10))
                                                    : (ariaSorts.value[field.key] &&
                                                        ariaSorts.value[field.key] === 'descending')
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_11))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                        ])
                                    ])
                                ], 10, _hoisted_6));
                            }), 128))
                        ], 2)
                    ], 2),
                    (0, vue_2.createElementVNode)("tbody", {
                        class: (0, vue_2.normalizeClass)(["bg-transparent divide-gray", {
                                'divide-y': !__props.condensed,
                                [__props.bodyExtraClasses]: __props.bodyExtraClasses.length,
                            }])
                    }, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.items, (item, itemIndex) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: item }, [
                                (0, vue_2.createElementVNode)("tr", {
                                    class: (0, vue_2.normalizeClass)(__props.bodyRowExtraClasses),
                                    onClick: ($event) => (rowClick($event, item))
                                }, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(visibleFields.value, (field) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                                            key: `${itemIndex}-${field.key}`
                                        }, [
                                            (0, vue_2.createElementVNode)("div", {
                                                class: "mobile-label",
                                                innerHTML: field.label
                                            }, null, 8, _hoisted_13),
                                            (0, vue_2.renderSlot)(_ctx.$slots, `cell-${field.key}`, { item: item }, () => [
                                                (typeof field.value === 'string')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                        key: 0,
                                                        innerHTML: cellValueParser(field.key, item)
                                                    }, null, 8, _hoisted_14))
                                                    : (typeof field.value === 'function')
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                            key: 1,
                                                            innerHTML: field.value(item)
                                                        }, null, 8, _hoisted_15))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                            ])
                                        ]));
                                    }), 128))
                                ], 10, _hoisted_12),
                                (0, vue_2.renderSlot)(_ctx.$slots, "afterRow", {
                                    item: item,
                                    visibleColumnsCount: visibleFields.value.length
                                })
                            ], 64));
                        }), 128)),
                        (__props.items.length === 0)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", _hoisted_16, [
                                (0, vue_2.createElementVNode)("td", {
                                    class: "text-center font-semibold uppercase tracking-widest",
                                    colspan: visibleFields.value.length
                                }, [
                                    (__props.isBusy)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$trans("loading", "Loading...", "responsive_table")), 1)
                                        ], 64))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$trans("there_is_no_data", "There is no data.", "responsive_table")), 1)
                                        ], 64))
                                ], 8, _hoisted_17)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ], 2),
                    (((0, vue_2.unref)(slots).footer && (0, vue_2.unref)(slots).footer().length) || __props.pagination)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tfoot", _hoisted_18, [
                            ((0, vue_2.unref)(slots).footer && (0, vue_2.unref)(slots).footer().length)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", _hoisted_19, [
                                    (0, vue_2.createElementVNode)("td", {
                                        colspan: visibleFields.value.length
                                    }, [
                                        (0, vue_2.renderSlot)(_ctx.$slots, "footer")
                                    ], 8, _hoisted_20)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (__props.pagination)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", _hoisted_21, [
                                    (0, vue_2.createElementVNode)("td", {
                                        colspan: visibleFields.value.length,
                                        class: "text-center border-t-1 border-gray-dark border-double bg-white"
                                    }, [
                                        (0, vue_2.createVNode)(Pagination_vue_1.default, {
                                            current: page.value,
                                            "onUpdate:current": _cache[1] || (_cache[1] = ($event) => ((page).value = $event)),
                                            total: __props.totalItems,
                                            "per-page": __props.itemsPerPage
                                        }, null, 8, ["current", "total", "per-page"])
                                    ], 8, _hoisted_22)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ], 2)
            ]));
        };
    }
});
